import { render, staticRenderFns } from "./DocxViewer.vue?vue&type=template&id=d4fb679c&scoped=true"
import script from "./DocxViewer.vue?vue&type=script&lang=js"
export * from "./DocxViewer.vue?vue&type=script&lang=js"
import style0 from "./DocxViewer.vue?vue&type=style&index=0&id=d4fb679c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4fb679c",
  null
  
)

export default component.exports